import React from 'react';
import useUiStore from '../../store/uiStore';
import { logger } from '../../../core/logging';

/**
 * Standard React ErrorBoundary that reports errors to `uiStore` as toasts.
 */
export default class ErrorBoundary extends React.Component<
  { fallback?: React.ReactNode; children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { fallback?: React.ReactNode; children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Log before the toast: if showToast itself throws, the crash is still recorded.
    logger.error('React component tree crashed', {
      error,
      componentStack: errorInfo?.componentStack,
    });

    // Use the store's getState to avoid calling hooks inside a class component
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (useUiStore as any).getState().showToast({ message: error.message || 'An error occurred', level: 'error' });
    } catch {
      // ignore failures reporting the error
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}
